/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AKSNodeClass } from '../models';
// @ts-ignore
import type { EC2NodeClass } from '../models';
// @ts-ignore
import type { ListAKSNodeClassesResponse } from '../models';
// @ts-ignore
import type { ListEC2NodeClassesResponse } from '../models';
// @ts-ignore
import type { ListNodeClassesResponse } from '../models';
// @ts-ignore
import type { NodeClass } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { UpdateAKSNodeClassResponse } from '../models';
// @ts-ignore
import type { UpdateEC2NodeClassResponse } from '../models';
// @ts-ignore
import type { UpdateNodeClassResponse } from '../models';
/**
 * NodeClassesAPIApi - axios parameter creator
 * @export
 */
export const NodeClassesAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deprecated: use ListNodeClasses instead.  list AKS nodeClasses rpc
         * @summary Lists AKS Node Classes.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster whose node classes are being listed.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeClassesAPIListAKSNodeClasses: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodeClassesAPIListAKSNodeClasses', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('nodeClassesAPIListAKSNodeClasses', 'clusterId', clusterId)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/aks-node-classes`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated: use ListNodeClasses instead.  add listnodeClasses rpc
         * @summary Lists EC2 Node Classes.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster whose node classes are being listed.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeClassesAPIListEC2NodeClasses: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodeClassesAPIListEC2NodeClasses', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('nodeClassesAPIListEC2NodeClasses', 'clusterId', clusterId)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/ec2-node-classes`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists NodeClasses for the given cluster, regardless of cloud provider.  Returns EC2NodeClass and AKSNodeClass payloads wrapped in the unified  NodeClass message; in practice a cluster only carries one provider\'s  classes.
         * @summary Lists Node Classes.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster whose node classes are being listed.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeClassesAPIListNodeClasses: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodeClassesAPIListNodeClasses', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('nodeClassesAPIListNodeClasses', 'clusterId', clusterId)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/node-classes`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated: use UpdateNodeClass instead.  Updates an existing AKSNodeClass. Used by the UI edit flow. Pass the full  AKSNodeClass object and the prior resourceVersion (from ListAKSNodeClasses  metadata.resourceVersion) as expected_resource_version for optimistic  concurrency: on drift the update fails with CONFLICT, surfaced as HTTP 409  (gRPC codes.Aborted) so the UI can prompt a reload.
         * @summary Updates an AKS Node Class.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster whose AKSNodeClass is being updated.
         * @param {string} name The name of the AKSNodeClass being updated. Must match node_class.metadata.name.
         * @param {AKSNodeClass} aKSNodeClass 
         * @param {string} [expectedResourceVersion] The resourceVersion observed by the UI on the prior read. Used for  optimistic concurrency (CONFLICT on drift → HTTP 409 equivalent).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeClassesAPIUpdateAKSNodeClass: async (organizationId: string, clusterId: string, name: string, aKSNodeClass: AKSNodeClass, expectedResourceVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodeClassesAPIUpdateAKSNodeClass', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('nodeClassesAPIUpdateAKSNodeClass', 'clusterId', clusterId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('nodeClassesAPIUpdateAKSNodeClass', 'name', name)
            // verify required parameter 'aKSNodeClass' is not null or undefined
            assertParamExists('nodeClassesAPIUpdateAKSNodeClass', 'aKSNodeClass', aKSNodeClass)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/aks-node-classes/{name}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (expectedResourceVersion !== undefined) {
                localVarQueryParameter['expectedResourceVersion'] = expectedResourceVersion;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aKSNodeClass, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated: use UpdateNodeClass instead.  Updates an existing EC2NodeClass. Used by the UI edit flow. Pass the full  EC2NodeClass object and the prior resourceVersion (from ListEC2NodeClasses  metadata.resourceVersion) as expected_resource_version for optimistic  concurrency: on drift the update fails with CONFLICT, surfaced as HTTP 409  (gRPC codes.Aborted) so the UI can prompt a reload.
         * @summary Updates an EC2 Node Class.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster whose EC2NodeClass is being updated.
         * @param {string} name The name of the EC2NodeClass being updated. Must match node_class.metadata.name.
         * @param {EC2NodeClass} eC2NodeClass 
         * @param {string} [expectedResourceVersion] The resourceVersion observed by the UI on the prior read. Used for  optimistic concurrency (CONFLICT on drift → HTTP 409 equivalent).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeClassesAPIUpdateEC2NodeClass: async (organizationId: string, clusterId: string, name: string, eC2NodeClass: EC2NodeClass, expectedResourceVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodeClassesAPIUpdateEC2NodeClass', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('nodeClassesAPIUpdateEC2NodeClass', 'clusterId', clusterId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('nodeClassesAPIUpdateEC2NodeClass', 'name', name)
            // verify required parameter 'eC2NodeClass' is not null or undefined
            assertParamExists('nodeClassesAPIUpdateEC2NodeClass', 'eC2NodeClass', eC2NodeClass)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/ec2-node-classes/{name}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (expectedResourceVersion !== undefined) {
                localVarQueryParameter['expectedResourceVersion'] = expectedResourceVersion;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eC2NodeClass, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing NodeClass regardless of cloud provider. The cloud  provider is inferred from the populated oneof variant of node_class.class.  Used by the UI edit flow. Pass the full NodeClass object and the prior  resourceVersion (from ListNodeClasses metadata.resourceVersion) as  expected_resource_version for optimistic concurrency: on drift the update  fails with CONFLICT, surfaced as HTTP 409 (gRPC codes.Aborted) so the UI  can prompt a reload.
         * @summary Updates a Node Class.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster whose NodeClass is being updated.
         * @param {string} name The name of the NodeClass being updated. Must match the metadata name of  the populated node_class variant.
         * @param {NodeClass} nodeClass 
         * @param {string} [expectedResourceVersion] The resourceVersion observed by the UI on the prior read. Used for  optimistic concurrency (CONFLICT on drift → HTTP 409 equivalent).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeClassesAPIUpdateNodeClass: async (organizationId: string, clusterId: string, name: string, nodeClass: NodeClass, expectedResourceVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodeClassesAPIUpdateNodeClass', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('nodeClassesAPIUpdateNodeClass', 'clusterId', clusterId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('nodeClassesAPIUpdateNodeClass', 'name', name)
            // verify required parameter 'nodeClass' is not null or undefined
            assertParamExists('nodeClassesAPIUpdateNodeClass', 'nodeClass', nodeClass)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/node-classes/{name}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (expectedResourceVersion !== undefined) {
                localVarQueryParameter['expectedResourceVersion'] = expectedResourceVersion;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nodeClass, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NodeClassesAPIApi - functional programming interface
 * @export
 */
export const NodeClassesAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NodeClassesAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Deprecated: use ListNodeClasses instead.  list AKS nodeClasses rpc
         * @summary Lists AKS Node Classes.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster whose node classes are being listed.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeClassesAPIListAKSNodeClasses(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAKSNodeClassesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeClassesAPIListAKSNodeClasses(organizationId, clusterId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeClassesAPIApi.nodeClassesAPIListAKSNodeClasses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deprecated: use ListNodeClasses instead.  add listnodeClasses rpc
         * @summary Lists EC2 Node Classes.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster whose node classes are being listed.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeClassesAPIListEC2NodeClasses(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListEC2NodeClassesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeClassesAPIListEC2NodeClasses(organizationId, clusterId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeClassesAPIApi.nodeClassesAPIListEC2NodeClasses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists NodeClasses for the given cluster, regardless of cloud provider.  Returns EC2NodeClass and AKSNodeClass payloads wrapped in the unified  NodeClass message; in practice a cluster only carries one provider\'s  classes.
         * @summary Lists Node Classes.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster whose node classes are being listed.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeClassesAPIListNodeClasses(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListNodeClassesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeClassesAPIListNodeClasses(organizationId, clusterId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeClassesAPIApi.nodeClassesAPIListNodeClasses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deprecated: use UpdateNodeClass instead.  Updates an existing AKSNodeClass. Used by the UI edit flow. Pass the full  AKSNodeClass object and the prior resourceVersion (from ListAKSNodeClasses  metadata.resourceVersion) as expected_resource_version for optimistic  concurrency: on drift the update fails with CONFLICT, surfaced as HTTP 409  (gRPC codes.Aborted) so the UI can prompt a reload.
         * @summary Updates an AKS Node Class.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster whose AKSNodeClass is being updated.
         * @param {string} name The name of the AKSNodeClass being updated. Must match node_class.metadata.name.
         * @param {AKSNodeClass} aKSNodeClass 
         * @param {string} [expectedResourceVersion] The resourceVersion observed by the UI on the prior read. Used for  optimistic concurrency (CONFLICT on drift → HTTP 409 equivalent).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeClassesAPIUpdateAKSNodeClass(organizationId: string, clusterId: string, name: string, aKSNodeClass: AKSNodeClass, expectedResourceVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateAKSNodeClassResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeClassesAPIUpdateAKSNodeClass(organizationId, clusterId, name, aKSNodeClass, expectedResourceVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeClassesAPIApi.nodeClassesAPIUpdateAKSNodeClass']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deprecated: use UpdateNodeClass instead.  Updates an existing EC2NodeClass. Used by the UI edit flow. Pass the full  EC2NodeClass object and the prior resourceVersion (from ListEC2NodeClasses  metadata.resourceVersion) as expected_resource_version for optimistic  concurrency: on drift the update fails with CONFLICT, surfaced as HTTP 409  (gRPC codes.Aborted) so the UI can prompt a reload.
         * @summary Updates an EC2 Node Class.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster whose EC2NodeClass is being updated.
         * @param {string} name The name of the EC2NodeClass being updated. Must match node_class.metadata.name.
         * @param {EC2NodeClass} eC2NodeClass 
         * @param {string} [expectedResourceVersion] The resourceVersion observed by the UI on the prior read. Used for  optimistic concurrency (CONFLICT on drift → HTTP 409 equivalent).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeClassesAPIUpdateEC2NodeClass(organizationId: string, clusterId: string, name: string, eC2NodeClass: EC2NodeClass, expectedResourceVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateEC2NodeClassResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeClassesAPIUpdateEC2NodeClass(organizationId, clusterId, name, eC2NodeClass, expectedResourceVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeClassesAPIApi.nodeClassesAPIUpdateEC2NodeClass']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing NodeClass regardless of cloud provider. The cloud  provider is inferred from the populated oneof variant of node_class.class.  Used by the UI edit flow. Pass the full NodeClass object and the prior  resourceVersion (from ListNodeClasses metadata.resourceVersion) as  expected_resource_version for optimistic concurrency: on drift the update  fails with CONFLICT, surfaced as HTTP 409 (gRPC codes.Aborted) so the UI  can prompt a reload.
         * @summary Updates a Node Class.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster whose NodeClass is being updated.
         * @param {string} name The name of the NodeClass being updated. Must match the metadata name of  the populated node_class variant.
         * @param {NodeClass} nodeClass 
         * @param {string} [expectedResourceVersion] The resourceVersion observed by the UI on the prior read. Used for  optimistic concurrency (CONFLICT on drift → HTTP 409 equivalent).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeClassesAPIUpdateNodeClass(organizationId: string, clusterId: string, name: string, nodeClass: NodeClass, expectedResourceVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateNodeClassResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeClassesAPIUpdateNodeClass(organizationId, clusterId, name, nodeClass, expectedResourceVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeClassesAPIApi.nodeClassesAPIUpdateNodeClass']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NodeClassesAPIApi - factory interface
 * @export
 */
export const NodeClassesAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NodeClassesAPIApiFp(configuration)
    return {
        /**
         * Deprecated: use ListNodeClasses instead.  list AKS nodeClasses rpc
         * @summary Lists AKS Node Classes.
         * @param {NodeClassesAPIApiNodeClassesAPIListAKSNodeClassesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeClassesAPIListAKSNodeClasses(requestParameters: NodeClassesAPIApiNodeClassesAPIListAKSNodeClassesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListAKSNodeClassesResponse> {
            return localVarFp.nodeClassesAPIListAKSNodeClasses(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated: use ListNodeClasses instead.  add listnodeClasses rpc
         * @summary Lists EC2 Node Classes.
         * @param {NodeClassesAPIApiNodeClassesAPIListEC2NodeClassesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeClassesAPIListEC2NodeClasses(requestParameters: NodeClassesAPIApiNodeClassesAPIListEC2NodeClassesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListEC2NodeClassesResponse> {
            return localVarFp.nodeClassesAPIListEC2NodeClasses(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists NodeClasses for the given cluster, regardless of cloud provider.  Returns EC2NodeClass and AKSNodeClass payloads wrapped in the unified  NodeClass message; in practice a cluster only carries one provider\'s  classes.
         * @summary Lists Node Classes.
         * @param {NodeClassesAPIApiNodeClassesAPIListNodeClassesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeClassesAPIListNodeClasses(requestParameters: NodeClassesAPIApiNodeClassesAPIListNodeClassesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListNodeClassesResponse> {
            return localVarFp.nodeClassesAPIListNodeClasses(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated: use UpdateNodeClass instead.  Updates an existing AKSNodeClass. Used by the UI edit flow. Pass the full  AKSNodeClass object and the prior resourceVersion (from ListAKSNodeClasses  metadata.resourceVersion) as expected_resource_version for optimistic  concurrency: on drift the update fails with CONFLICT, surfaced as HTTP 409  (gRPC codes.Aborted) so the UI can prompt a reload.
         * @summary Updates an AKS Node Class.
         * @param {NodeClassesAPIApiNodeClassesAPIUpdateAKSNodeClassRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeClassesAPIUpdateAKSNodeClass(requestParameters: NodeClassesAPIApiNodeClassesAPIUpdateAKSNodeClassRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateAKSNodeClassResponse> {
            return localVarFp.nodeClassesAPIUpdateAKSNodeClass(requestParameters.organizationId, requestParameters.clusterId, requestParameters.name, requestParameters.aKSNodeClass, requestParameters.expectedResourceVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated: use UpdateNodeClass instead.  Updates an existing EC2NodeClass. Used by the UI edit flow. Pass the full  EC2NodeClass object and the prior resourceVersion (from ListEC2NodeClasses  metadata.resourceVersion) as expected_resource_version for optimistic  concurrency: on drift the update fails with CONFLICT, surfaced as HTTP 409  (gRPC codes.Aborted) so the UI can prompt a reload.
         * @summary Updates an EC2 Node Class.
         * @param {NodeClassesAPIApiNodeClassesAPIUpdateEC2NodeClassRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeClassesAPIUpdateEC2NodeClass(requestParameters: NodeClassesAPIApiNodeClassesAPIUpdateEC2NodeClassRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateEC2NodeClassResponse> {
            return localVarFp.nodeClassesAPIUpdateEC2NodeClass(requestParameters.organizationId, requestParameters.clusterId, requestParameters.name, requestParameters.eC2NodeClass, requestParameters.expectedResourceVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing NodeClass regardless of cloud provider. The cloud  provider is inferred from the populated oneof variant of node_class.class.  Used by the UI edit flow. Pass the full NodeClass object and the prior  resourceVersion (from ListNodeClasses metadata.resourceVersion) as  expected_resource_version for optimistic concurrency: on drift the update  fails with CONFLICT, surfaced as HTTP 409 (gRPC codes.Aborted) so the UI  can prompt a reload.
         * @summary Updates a Node Class.
         * @param {NodeClassesAPIApiNodeClassesAPIUpdateNodeClassRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeClassesAPIUpdateNodeClass(requestParameters: NodeClassesAPIApiNodeClassesAPIUpdateNodeClassRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateNodeClassResponse> {
            return localVarFp.nodeClassesAPIUpdateNodeClass(requestParameters.organizationId, requestParameters.clusterId, requestParameters.name, requestParameters.nodeClass, requestParameters.expectedResourceVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for nodeClassesAPIListAKSNodeClasses operation in NodeClassesAPIApi.
 * @export
 * @interface NodeClassesAPIApiNodeClassesAPIListAKSNodeClassesRequest
 */
export interface NodeClassesAPIApiNodeClassesAPIListAKSNodeClassesRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIListAKSNodeClasses
     */
    readonly organizationId: string

    /**
     * The ID of the cluster whose node classes are being listed.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIListAKSNodeClasses
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIListAKSNodeClasses
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIListAKSNodeClasses
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for nodeClassesAPIListEC2NodeClasses operation in NodeClassesAPIApi.
 * @export
 * @interface NodeClassesAPIApiNodeClassesAPIListEC2NodeClassesRequest
 */
export interface NodeClassesAPIApiNodeClassesAPIListEC2NodeClassesRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIListEC2NodeClasses
     */
    readonly organizationId: string

    /**
     * The ID of the cluster whose node classes are being listed.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIListEC2NodeClasses
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIListEC2NodeClasses
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIListEC2NodeClasses
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for nodeClassesAPIListNodeClasses operation in NodeClassesAPIApi.
 * @export
 * @interface NodeClassesAPIApiNodeClassesAPIListNodeClassesRequest
 */
export interface NodeClassesAPIApiNodeClassesAPIListNodeClassesRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIListNodeClasses
     */
    readonly organizationId: string

    /**
     * The ID of the cluster whose node classes are being listed.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIListNodeClasses
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIListNodeClasses
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIListNodeClasses
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for nodeClassesAPIUpdateAKSNodeClass operation in NodeClassesAPIApi.
 * @export
 * @interface NodeClassesAPIApiNodeClassesAPIUpdateAKSNodeClassRequest
 */
export interface NodeClassesAPIApiNodeClassesAPIUpdateAKSNodeClassRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIUpdateAKSNodeClass
     */
    readonly organizationId: string

    /**
     * The ID of the cluster whose AKSNodeClass is being updated.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIUpdateAKSNodeClass
     */
    readonly clusterId: string

    /**
     * The name of the AKSNodeClass being updated. Must match node_class.metadata.name.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIUpdateAKSNodeClass
     */
    readonly name: string

    /**
     * 
     * @type {AKSNodeClass}
     * @memberof NodeClassesAPIApiNodeClassesAPIUpdateAKSNodeClass
     */
    readonly aKSNodeClass: AKSNodeClass

    /**
     * The resourceVersion observed by the UI on the prior read. Used for  optimistic concurrency (CONFLICT on drift → HTTP 409 equivalent).
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIUpdateAKSNodeClass
     */
    readonly expectedResourceVersion?: string
}

/**
 * Request parameters for nodeClassesAPIUpdateEC2NodeClass operation in NodeClassesAPIApi.
 * @export
 * @interface NodeClassesAPIApiNodeClassesAPIUpdateEC2NodeClassRequest
 */
export interface NodeClassesAPIApiNodeClassesAPIUpdateEC2NodeClassRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIUpdateEC2NodeClass
     */
    readonly organizationId: string

    /**
     * The ID of the cluster whose EC2NodeClass is being updated.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIUpdateEC2NodeClass
     */
    readonly clusterId: string

    /**
     * The name of the EC2NodeClass being updated. Must match node_class.metadata.name.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIUpdateEC2NodeClass
     */
    readonly name: string

    /**
     * 
     * @type {EC2NodeClass}
     * @memberof NodeClassesAPIApiNodeClassesAPIUpdateEC2NodeClass
     */
    readonly eC2NodeClass: EC2NodeClass

    /**
     * The resourceVersion observed by the UI on the prior read. Used for  optimistic concurrency (CONFLICT on drift → HTTP 409 equivalent).
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIUpdateEC2NodeClass
     */
    readonly expectedResourceVersion?: string
}

/**
 * Request parameters for nodeClassesAPIUpdateNodeClass operation in NodeClassesAPIApi.
 * @export
 * @interface NodeClassesAPIApiNodeClassesAPIUpdateNodeClassRequest
 */
export interface NodeClassesAPIApiNodeClassesAPIUpdateNodeClassRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIUpdateNodeClass
     */
    readonly organizationId: string

    /**
     * The ID of the cluster whose NodeClass is being updated.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIUpdateNodeClass
     */
    readonly clusterId: string

    /**
     * The name of the NodeClass being updated. Must match the metadata name of  the populated node_class variant.
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIUpdateNodeClass
     */
    readonly name: string

    /**
     * 
     * @type {NodeClass}
     * @memberof NodeClassesAPIApiNodeClassesAPIUpdateNodeClass
     */
    readonly nodeClass: NodeClass

    /**
     * The resourceVersion observed by the UI on the prior read. Used for  optimistic concurrency (CONFLICT on drift → HTTP 409 equivalent).
     * @type {string}
     * @memberof NodeClassesAPIApiNodeClassesAPIUpdateNodeClass
     */
    readonly expectedResourceVersion?: string
}

/**
 * NodeClassesAPIApi - object-oriented interface
 * @export
 * @class NodeClassesAPIApi
 * @extends {BaseAPI}
 */
export class NodeClassesAPIApi extends BaseAPI {
    /**
     * Deprecated: use ListNodeClasses instead.  list AKS nodeClasses rpc
     * @summary Lists AKS Node Classes.
     * @param {NodeClassesAPIApiNodeClassesAPIListAKSNodeClassesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeClassesAPIApi
     */
    public nodeClassesAPIListAKSNodeClasses(requestParameters: NodeClassesAPIApiNodeClassesAPIListAKSNodeClassesRequest, options?: RawAxiosRequestConfig) {
        return NodeClassesAPIApiFp(this.configuration).nodeClassesAPIListAKSNodeClasses(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated: use ListNodeClasses instead.  add listnodeClasses rpc
     * @summary Lists EC2 Node Classes.
     * @param {NodeClassesAPIApiNodeClassesAPIListEC2NodeClassesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeClassesAPIApi
     */
    public nodeClassesAPIListEC2NodeClasses(requestParameters: NodeClassesAPIApiNodeClassesAPIListEC2NodeClassesRequest, options?: RawAxiosRequestConfig) {
        return NodeClassesAPIApiFp(this.configuration).nodeClassesAPIListEC2NodeClasses(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists NodeClasses for the given cluster, regardless of cloud provider.  Returns EC2NodeClass and AKSNodeClass payloads wrapped in the unified  NodeClass message; in practice a cluster only carries one provider\'s  classes.
     * @summary Lists Node Classes.
     * @param {NodeClassesAPIApiNodeClassesAPIListNodeClassesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeClassesAPIApi
     */
    public nodeClassesAPIListNodeClasses(requestParameters: NodeClassesAPIApiNodeClassesAPIListNodeClassesRequest, options?: RawAxiosRequestConfig) {
        return NodeClassesAPIApiFp(this.configuration).nodeClassesAPIListNodeClasses(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated: use UpdateNodeClass instead.  Updates an existing AKSNodeClass. Used by the UI edit flow. Pass the full  AKSNodeClass object and the prior resourceVersion (from ListAKSNodeClasses  metadata.resourceVersion) as expected_resource_version for optimistic  concurrency: on drift the update fails with CONFLICT, surfaced as HTTP 409  (gRPC codes.Aborted) so the UI can prompt a reload.
     * @summary Updates an AKS Node Class.
     * @param {NodeClassesAPIApiNodeClassesAPIUpdateAKSNodeClassRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeClassesAPIApi
     */
    public nodeClassesAPIUpdateAKSNodeClass(requestParameters: NodeClassesAPIApiNodeClassesAPIUpdateAKSNodeClassRequest, options?: RawAxiosRequestConfig) {
        return NodeClassesAPIApiFp(this.configuration).nodeClassesAPIUpdateAKSNodeClass(requestParameters.organizationId, requestParameters.clusterId, requestParameters.name, requestParameters.aKSNodeClass, requestParameters.expectedResourceVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated: use UpdateNodeClass instead.  Updates an existing EC2NodeClass. Used by the UI edit flow. Pass the full  EC2NodeClass object and the prior resourceVersion (from ListEC2NodeClasses  metadata.resourceVersion) as expected_resource_version for optimistic  concurrency: on drift the update fails with CONFLICT, surfaced as HTTP 409  (gRPC codes.Aborted) so the UI can prompt a reload.
     * @summary Updates an EC2 Node Class.
     * @param {NodeClassesAPIApiNodeClassesAPIUpdateEC2NodeClassRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeClassesAPIApi
     */
    public nodeClassesAPIUpdateEC2NodeClass(requestParameters: NodeClassesAPIApiNodeClassesAPIUpdateEC2NodeClassRequest, options?: RawAxiosRequestConfig) {
        return NodeClassesAPIApiFp(this.configuration).nodeClassesAPIUpdateEC2NodeClass(requestParameters.organizationId, requestParameters.clusterId, requestParameters.name, requestParameters.eC2NodeClass, requestParameters.expectedResourceVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing NodeClass regardless of cloud provider. The cloud  provider is inferred from the populated oneof variant of node_class.class.  Used by the UI edit flow. Pass the full NodeClass object and the prior  resourceVersion (from ListNodeClasses metadata.resourceVersion) as  expected_resource_version for optimistic concurrency: on drift the update  fails with CONFLICT, surfaced as HTTP 409 (gRPC codes.Aborted) so the UI  can prompt a reload.
     * @summary Updates a Node Class.
     * @param {NodeClassesAPIApiNodeClassesAPIUpdateNodeClassRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeClassesAPIApi
     */
    public nodeClassesAPIUpdateNodeClass(requestParameters: NodeClassesAPIApiNodeClassesAPIUpdateNodeClassRequest, options?: RawAxiosRequestConfig) {
        return NodeClassesAPIApiFp(this.configuration).nodeClassesAPIUpdateNodeClass(requestParameters.organizationId, requestParameters.clusterId, requestParameters.name, requestParameters.nodeClass, requestParameters.expectedResourceVersion, options).then((request) => request(this.axios, this.basePath));
    }
}

